import { ReactComponent as ArrowRightSvg } from '../../../assets/svgs/chev-right.svg'
import { ReactComponent as ArrowLeftSvg } from '../../../assets/svgs/chev-left.svg'
import { PaginationItem } from './PaginationItem'

type PaginationProps = {
  currentPage: number
  totalCountOfRegisters: number
  registersPerPage: number
  siblingsCount?: number
  onPageChange: (pageNumber: number) => void
}

const generatePagesArray = (from: number, to: number) => {
  return [...new Array(to - from)]
    .map((_, index) => from + index + 1)
    .filter((page) => page > 0)
}

export const Pagination = ({
  currentPage,
  totalCountOfRegisters,
  registersPerPage,
  siblingsCount = 2,
  onPageChange,
}: PaginationProps) => {
  const lastPage = Math.ceil(totalCountOfRegisters / registersPerPage)
  const newPageIsBiggerThanCurrentPage = currentPage + 1 > lastPage
  const newPageIsSmallerThanTheFirstPage = currentPage - 1 < 1

  const previousPageRelativeCurrentPage =
    currentPage - 1
      ? generatePagesArray(currentPage - 1 - siblingsCount, currentPage - 1)
      : []

  const nextPageRelativeCurrentPage =
    currentPage < lastPage
      ? generatePagesArray(
        currentPage,
        Math.min(currentPage + siblingsCount, lastPage)
      )
      : []

  const handlePreviousButtonClick = () => {
    if (!newPageIsSmallerThanTheFirstPage) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNextButtonClick = () => {
    if (!newPageIsBiggerThanCurrentPage) {
      onPageChange(currentPage + 1)
    }
  }

  return (
    <div className="flex items-center self-center gap-2 lg:gap-3">
      <button
        className="h-8 px-3 rounded-lg bg-grey-100 disabled:opacity-40"
        disabled={newPageIsSmallerThanTheFirstPage}
        onClick={() => handlePreviousButtonClick()}
      >
        <ArrowLeftSvg />
      </button>

      <div className="flex items-center gap-1 lg:gap-3">
        {currentPage > 1 + siblingsCount && (
          <>
            <PaginationItem pageNumber={1} onPageChange={onPageChange} />
            {currentPage > 2 + siblingsCount && (
              <span className="flex items-center justify-center bg-grey-100 px-[10px] text-xs font-normal h-8 rounded-lg">
                ...
              </span>
            )}
          </>
        )}

        {previousPageRelativeCurrentPage.length > 0 &&
          previousPageRelativeCurrentPage.map((pageNumber) => (
            <PaginationItem
              key={pageNumber}
              pageNumber={pageNumber}
              onPageChange={onPageChange}
            />
          ))}

        <PaginationItem
          isCurrent
          pageNumber={currentPage}
          onPageChange={onPageChange}
        />

        {nextPageRelativeCurrentPage.length > 0 &&
          nextPageRelativeCurrentPage.map((pageNumber) => (
            <PaginationItem
              key={pageNumber}
              pageNumber={pageNumber}
              onPageChange={onPageChange}
            />
          ))}

        {currentPage + siblingsCount < lastPage && (
          <>
            {currentPage + 1 + siblingsCount < lastPage && (
              <>
                <span className="flex items-center justify-center bg-grey-100 px-[10px] text-xs font-normal h-8 rounded-lg">
                  ...
                </span>

                <PaginationItem
                  pageNumber={lastPage}
                  onPageChange={onPageChange}
                />
              </>
            )}
          </>
        )}
      </div>

      <button
        className="h-8 px-3 rounded-lg bg-grey-100 disabled:opacity-40"
        onClick={handleNextButtonClick}
        disabled={newPageIsBiggerThanCurrentPage}
      >
        <ArrowRightSvg />
      </button>
    </div>
  )
}
